module.exports = __webpack_public_path__ + "static/livestream-eb42ed76f3e5ddab7ad9297b247dd3e4.png";